export default __webpack_public_path__ + "images/new-customer-image-2.59d866cd8b420a20fd2919332afd8e4f.png";